module.exports = __webpack_public_path__ + "static/media/civic.ec304491.jpg";